module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1517-709bcaabf88e1185e5cfb2b11ec840ef.png";